import styled, { css } from 'styled-components';

import { Box } from '../Box';
import { NextImage } from '../NextImage';
import { Typography } from '../Typography';

import { ReactComponent as PlusSVG } from '@/assets/icons/plus.svg';

export const ButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.primaryBlue};
`;

export const AddButton = styled.button`
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}

  :hover ${ButtonText} {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
`;

export const ButtonContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  transform-origin: top center;

  animation: add-strap-button-unfold 320ms cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  @keyframes add-strap-button-unfold {
    from {
      transform: translateY(-100%) scaleY(0.8);
      clip-path: inset(0 0 100% 0);
    }
    to {
      transform: translateY(0) scaleY(1);
      clip-path: inset(0);
    }
  }
`;

export const PlusIcon = styled(PlusSVG)`
  width: 24px;
  height: 24px;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const ButtonImage = styled(NextImage)`
  object-fit: contain;
`;

export const ButtonImageWrapper = styled(Box)<{ $iconRight: boolean }>`
  height: 56px;
  width: 120px;
  margin-left: ${({ $iconRight, theme }) =>
    $iconRight ? 'auto' : theme.spacing(2)};
  position: relative;
`;
